import styled from 'styled-components';

export const StyledBackofficeMenu = styled.nav`
  font-size: 10px;
  font-family: 'Poppins', sans-serif;
  background-color: #2E2D37;
  color: #FFFFFF;
  max-width: 250px;
  flex-grow: 1;
  padding: 24px 0 64px;
  position: relative;
  z-index: 2;
  box-sizing: border-box;

	i.fa-spinner {
		font-size: 18px;
    padding: 0 32px;
	}
  
  ul {
  	list-style: none;
  	margin: 0;
  	padding: 0;
  	
  	li {
  		color: #FFFFFF;
			line-height: 40px;
		  padding: 0 32px;
		  display: block;
		  width: 100%;
		  background-color: transparent;
		  color: #FFFFFF;
		  fill: #FFFFFF;
		  opacity: 0.7;
		  transition: opacity 0.3s;
		  text-align: left;

			.icon {
				font-size: 15px;
			}

			a {
				color: #FFFFFF;
				text-decoration: none;

				&:hover {
					opacity: 0.5;	
				}	
			}
  	}
  }
`;
